import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import Person from '@mui/icons-material/Person'
import API from '../../../../services/API'
import { GlobalContext, UserContext } from '../../../../App'
import { LoadingSmall } from '../../../loading/loadingPage'

const AssignToMe = ({ drugBag, setView }) => {
  const { setToast } = useContext(GlobalContext)
  const { user } = useContext(UserContext)
  const canAssignToEmployee = !!user?.employee?._id

  const handleConfirm = () => {
    if (!canAssignToEmployee) return
    API.post('/medsmx/newlocation', {
      employee: user.employee._id,
      id: drugBag._id,
    }).then((res) => {
      if (res.status === 200) {
        setView('home')
        setToast({ message: 'Bag assigned to you' })
      }
    })
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            display: 'grid',
            placeItems: 'center',
            color: '#9B287B',
            backgroundColor: '#9B287B14',
          }}
        >
          <Person />
        </Box>

        <Stack spacing={0.5} textAlign="center">
          <Typography variant="h6" fontWeight={950}>
            Assign {drugBag.name} to you?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This records the bag as checked out to your employee profile.
          </Typography>
        </Stack>

        {!canAssignToEmployee && (
          <Alert severity="warning" sx={{ width: '100%' }}>
            Drug bags can only be assigned to employee accounts.
          </Alert>
        )}

        {user && drugBag?._id ? (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width="100%">
            <Button
              onClick={handleConfirm}
              variant="contained"
              fullWidth
              disabled={!canAssignToEmployee}
              sx={{
                borderRadius: 1.5,
                textTransform: 'none',
                fontWeight: 900,
                backgroundColor: '#1E7F88',
              }}
            >
              Assign to me
            </Button>
            <Button
              onClick={() => setView('home')}
              variant="outlined"
              fullWidth
              sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 850 }}
            >
              Cancel
            </Button>
          </Stack>
        ) : (
          <LoadingSmall />
        )}
      </Stack>
    </Paper>
  )
}

export default AssignToMe
